module.exports = __webpack_public_path__ + "img/nginx-f5.cb8fd70d.png";